import PropTypes from 'prop-types';
import React from 'react';
import Loader from '../misc/Loader.react';
import cx from '../../utils/cx.js';
import get from 'lodash/get';

const ReactPropTypes = PropTypes;

class GalleryThumb extends React.Component {
	static propTypes = {
	  filename: ReactPropTypes.string,
	  size: ReactPropTypes.string,
	  sex: ReactPropTypes.string,
	  active: ReactPropTypes.bool,
	  onClick: ReactPropTypes.func,
	  gcloud: ReactPropTypes.bool,
	  uncensored: ReactPropTypes.bool,
	};

	static defaultProps = {
	  filename: null,
	  size: 's', // s - 100x100
	  sex: null, // f - sieviete, m - vīrietis
	  active: false, // pazīme, ka aktīva bilde
	  onClick: null,
	  gcloud: false,
	  uncensored: false,
	};

	shouldComponentUpdate(nextProps, nextState) {
	  // render tikai tad, kad ir notikušas izmaiņas
	  if (nextProps.active !== this.props.active || nextProps.uncensored !== this.props.uncensored) {
	    return true;
	  }

	  return false;
	}

	onClick = (e) => {
	  e.preventDefault();
	  this.props.onClick();
	}

	render() {
	  const targetBasePath = this.props.gcloud ? 'gcloudUri' : 'fullStaticImageUri';
	  let filename = this.props.filename;
	  if (this.props.gcloud && !filename.includes('jpg')) {
		  filename += '.jpg';
	  }

	  var fullFilename = `${get(globals, targetBasePath, '') + this.props.size}/${filename}`;

	  // pievieno dzimuma parametru, lai atgrieztu korektu bildi, ja neizdoas ielādēt
	  if (this.props.sex && !this.props.gcloud) {
	    fullFilename += `/${this.props.sex}`;
	  }

	  if (this.props.filename.match(/\.(jpeg|jpg|gif|png)(?:[\?]+[A-Za-z0-9_.-\/=&-]+)?$/) != null && !this.props.gcloud) {
	    var fullFilename = this.props.filename;
	  }

	  return (
	    <a
	      href="#"
	      className={cx([
	        'galleryThumb',
	        ['is-active', this.props.active],
	        ['galleryThumb--uncensored', this.props.uncensored],
	      ])}
	      onClick={this.onClick}
	    >
	      <img src={fullFilename} alt="" />
	      <div className="galleryThumb-outline" />
	    </a>
	  );
	}
}

module.exports = GalleryThumb;
